'use client';

import type { FC } from 'react';
import { useLocalTranslation } from '../hooks/useLocalTranslation';
import translations from './ErrorMessage.translations';
import { Button, Text, Title } from './ui';

interface ErrorMessageProps {
  /**
   * Поясняющая строка под заголовком — **только переведённая**. Сырой текст исключения
   * или сообщение бэкенда сюда не передаём: они на английском и написаны для
   * разработчика («Failed to fetch», «rule … violated»), а экран может быть открыт в
   * ru или uz. Нечего сказать по-человечески — не передавай ничего: заголовок и кнопка
   * повтора переведены и осмысленны сами по себе.
   */
  error?: string;
  message?: string;
  onRetry?: () => void;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ error, message, onRetry }) => {
  const { t } = useLocalTranslation(translations);
  const body = message || error;

  return (
    <div className="max-w-[400px] mx-auto p-5 text-center">
      <div className="bg-black rounded-lg p-5 mb-4">
        <div className="text-5xl mb-4">❌</div>
        <Title level="3" weight="2">
          {t('errorOccurred')}
        </Title>
        {body && <Text>{body}</Text>}
      </div>

      {onRetry && (
        <Button onClick={onRetry} size="l" stretched>
          {t('retry')}
        </Button>
      )}
    </div>
  );
};
